@if (form) {
  <form [formGroup]="form">
    @if (loaded) {
      <se-fe-form-field
    [seFeDataConfig]="{
      label: seFeDataLabel,
      errorMessages: {
        required: 'SE_PO_UI_MILITARY_SELECT.ERRORS.required' | translate
      }
    }">
      <se-fe-form-field-select
        [formControlName]="ngControl.name"
        [seFeDataOptions]="militaryStatusOptions"
        [seFeDataComfy]="true">
      </se-fe-form-field-select>
    </se-fe-form-field>
  }
</form>
}
